import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=6b0f41b3&scoped=true&lang=pug"
import script from "./BranchList.vue?vue&type=script&lang=ts"
export * from "./BranchList.vue?vue&type=script&lang=ts"
import style0 from "./BranchList.vue?vue&type=style&index=0&id=6b0f41b3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f41b3",
  null
  
)

export default component.exports